import React, { forwardRef, } from "react";
import { IconButton as ChakraIconButton, Icon, useStyleConfig, } from "@chakra-ui/react";
export const IconButton = forwardRef(({ icon, size = "md", ...props }, ref) => {
    const { h } = useStyleConfig("Button", { size });
    return (React.createElement(ChakraIconButton, { ref: ref, icon: React.createElement(Icon, { as: icon, boxSize: size === "lg" ? 6 : 4 }), variant: "ghost", width: Number(h), height: Number(h), minWidth: "0", ...props }));
});
